module.exports = __webpack_public_path__ + "files/7fc8d73b59507da0f613252fde98517e.png";